import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Placeholder, PlaceholderLine } from '@/src/elements/placeholder'

export const HeaderPlaceholder = ({ testID }: { testID: string }): ReactNode => (
  <View testID={testID}>
    <Placeholder className="flex-1">
      <PlaceholderLine size="md" />
    </Placeholder>
    <Placeholder noBackground className="mt-5 flex-col">
      <PlaceholderLine contrast="light" size="sm" />
      <PlaceholderLine contrast="light" size="sm" className="mt-2 w-2/6" />
    </Placeholder>
  </View>
)
